import React, { useState, useEffect } from 'react';
import { Col, Card, CardBody, Spinner, Alert, Badge } from 'reactstrap';
import * as actions from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import AdminRow from './AdminRow';

export default function Admins() {
    const { admins, loading, error } = useSelector(state => state.settings);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.fetchAdminsRequest());
    }, [dispatch]);

    const getRoleBadgeColor = (role) => {
        return role === 'super_admin' ? 'primary' : 'info';
    };

    const getRoleText = (role) => {
        return role === 'super_admin' ? 'مشرف عام' : 'مشرف';
    };

    return (
        <Col xl={9} className="mb-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                    <div className="avatar-sm me-3">
                        <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-20">
                            <i className="bx bx-group"></i>
                        </span>
                    </div>
                    <div>
                        <h5 className="mb-1">قائمة المشرفين</h5>
                        <p className="text-muted mb-0">إدارة صلاحيات المشرفين</p>
                    </div>
                </div>
                <Badge color="primary" className="font-size-14">
                    {admins?.length || 0} مشرف
                </Badge>
            </div>

            <Card className="border shadow-sm" style={{ borderRadius: '12px' }}>
                <CardBody className="p-0">
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <p className="mt-2 text-muted">جاري التحميل...</p>
                        </div>
                    ) : error ? (
                        <Alert color="danger" className="m-4">
                            <i className="bx bx-error-circle me-2"></i>
                            {error}
                        </Alert>
                    ) : !admins?.length ? (
                        <Alert color="info" className="m-4">
                            <i className="bx bx-info-circle me-2"></i>
                            لا يوجد مشرفين مسجلين
                        </Alert>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="px-4 py-3">
                                            <i className="bx bx-user me-2"></i>
                                            الاسم
                                        </th>
                                        <th className="py-3">
                                            <i className="bx bx-envelope me-2"></i>
                                            البريد الإلكتروني
                                        </th>
                                        <th className="py-3">
                                            <i className="bx bx-shield me-2"></i>
                                            الدور
                                        </th>
                                        <th className="py-3 text-center">
                                            <i className="bx bx-refresh me-2"></i>
                                            تغيير الدور
                                        </th>
                                        <th className="py-3 text-center">
                                            <i className="bx bx-lock-alt me-2"></i>
                                            كلمة المرور
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {admins.map(admin => (
                                        <AdminRow key={admin.id} admin={admin} />
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </CardBody>
            </Card>

            <Alert color="warning" className="mt-3 border-0 shadow-sm" style={{ borderRadius: '8px' }}>
                <i className="bx bx-error-circle me-2"></i>
                <strong>تحذير:</strong> كن حذراً عند تغيير صلاحيات المشرفين.
            </Alert>
        </Col>
    );
}